import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IService {
  idService: number;
  serviceName: string;
}

export interface ServicesState {
  list: IService[];
  isLoaded: boolean;
}

export const initialState: ServicesState = {
  list: [],
  isLoaded: false,
};

export const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    setServices: (state, action: PayloadAction<IService[]>) => {
      state.list = action.payload;
      state.isLoaded = true;
    },
    clearServices: (state) => {
      state.list = [];
      state.isLoaded = false;
    },
  },
});

export default servicesSlice.reducer;
export const { setServices, clearServices } = servicesSlice.actions;
